import InputFile, { Props as ComponentProps } from 'components/InputFile';
import { Field, Validator } from 'redux-form';
import * as React from 'react';

interface Props extends ComponentProps {
  name: string;
  validate?: Validator[];
  className: string;
}

const InputFileField: React.FC<Props> = ({
  className,
  name,
  validate,
  ...props
}) => {
  return (
    <Field
      className={className}
      component={InputFile}
      name={name}
      validate={validate}
      {...props}
    />
  );
};

export default InputFileField;
